module.exports = __webpack_public_path__ + "img/Cbird.6a53b899.png";